<template>
    <div class="row onde-encontrar-layout" style="background-color: white;" >
        <!-- Filtros -->
        <div
            v-if="deveRenderizarPesquisa"
            ref="painelResultados"
            class="col s12 m4 painel-resultados"
            @scroll.passive="aoScrollResultados"
        >
            <div class="row">
              <div class="col s12">
                  <span class="pt-1">
                      Seu local<span v-if="cidadeUsuario"> <i class="material-icons prefix tiny">location_on</i>: <strong class="blue-text">{{cidadeUsuario}}</strong></span>
                  </span>
              </div>
            </div>
            <div v-if="mensagemLocalizacao" class="row">
                <div class="col s12">
                    <div class="localizacao-fallback-msg">
                        {{ mensagemLocalizacao }}
                    </div>
                </div>
            </div>
            <div class="row card pt-2">
                <div class="input-field col s12 ">
                    <i class="material-icons prefix">search</i>
                    <input id="last_name" type="text" class="validate" v-model="searchQuery" @keypress.enter="buscarProdutos">
                    <label for="last_name">Procure um produto</label>
                </div>
                <div class="col s12 pb-2">
                    <a
                        class="waves-effect waves-light btn right"
                        :class="{ disabled: carregandoProdutos }"
                        @click.prevent="buscarProdutos"
                    >
                        <span v-if="!carregandoProdutos">Buscar</span>
                        <span v-else>Carregando...</span>
                    </a>
                </div>
            </div>
            <div v-if="carregandoProdutos" class="row">
                <div class="col s12">
                    <div class="busca-loading">
                        <div class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-blue-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                        <span>Carregando resultados...</span>
                    </div>
                </div>
            </div>
            <div class="row divider" v-if="produtoLista.length > 0"></div>
            <!-- Resultado da busca -->
            <div class="row" v-for="(produto, index) in produtoLista" :key="index">
                <div class="col s12 m3">
                    <img class="responsive-img"
                        :src="`webapi/item/${produto.id}/fotoLow`"
                        @error="handleImageError"
                    >
                </div>
                <div class="col s12 m9">
                    <div class="row" >
                        <div class="col s12">
                          <div class="row">
                            <div class="col s12">
                              <strong>{{produto.descricao}}</strong>
                            </div>
                            <div class="col s12">
                              <span>Item: {{produto.sku}} / C&oacute;d. fabricante: {{produto.skuFabricante}}</span>
                            </div>
                            <div class="col s12">
                              <span>{{produto.atributo1}}</span>
                            </div>

                          </div>  
                        </div>
                        <div class="col s12 pt-1">
                            <a class="waves-effect waves-light btn right" @click.prevent="buscarCoordenadas(produto.sku)">Encontrar</a>
                        </div>
                    </div>
                </div>
                <div class="col s12 divider"></div>
            </div>
        </div>
        <!-- Mapa -->
        <div v-if="deveRenderizarMapa" class="col s12 m8 painel-mapa">
            <div class="row mapa-mobile-acoes hide-on-med-and-up">
                <div class="col s12">
                    <a class="waves-effect waves-light btn" @click.prevent="novaPesquisaMobile">Nova pesquisa</a>
                </div>
            </div>
            <div ref="mapaWrapper" class="mapa-wrapper z-depth-1" tabindex="-1">
                <GmapMap
                    ref="mapaOndeEncontrar"
                    :key="mapRenderKey"
                    class="mapa-onde-encontrar"
                    :center="mapCenter"
                    :zoom="mapZoom"
                    :options="mapOptions"
                    @tilesloaded="aoCarregarMapa"
                    @idle="atualizarBoundsMapa"
                    @dragend="atualizarBoundsMapa"
                    @zoom_changed="atualizarBoundsMapa"
                >
                    <GmapMarker
                        v-if="localizacaoUsuario"
                        :position="mapCenter"
                        :title="'Sua localização'"
                        :icon="userMarkerIcon"
                    />
                    <!-- <template v-if="coordenadasLista.length > 0"> -->
                      <GmapMarker
                          v-for="(coordenada, index) in coordenadasLista"
                          :key="coordenada.id || index"
                          :position="{ lat: coordenada.lat, lng: coordenada.lng }"
                          :title="coordenada.clieNome"
                          @click="abrirDetalhesCliente(coordenada)"
                      />
                    <!-- </template> -->
                    <GmapInfoWindow
                        v-if="clienteSelecionado"
                        :position="{ lat: clienteSelecionado.lat, lng: clienteSelecionado.lng }"
                        :opened="infoWindowAberta"
                        @closeclick="fecharDetalhesCliente"
                    >
                        <div class="info-window-cliente">
                            <strong>{{ clienteSelecionado.clieNome }}</strong>
                            <div v-if="clienteSelecionado.clieTelefone">
                                <i class="material-icons prefix tiny">local_phone</i> {{ clienteSelecionado.clieTelefone | telefone}}
                            </div>
                            <div>
                                {{ clienteSelecionado.clenLogradouro }}, {{ clienteSelecionado.clenNumero }}
                            </div>
                            <div>
                                {{ clienteSelecionado.clenBairro }}
                            </div>
                            <div>
                                {{ clienteSelecionado.clenMunicipio }} - {{ clienteSelecionado.clenEstado }}
                            </div>
                            <div v-if="clienteSelecionado.clenCep">
                                CEP: {{ clienteSelecionado.clenCep }}
                            </div>
                            <div v-if="clienteSelecionado.distanciaKm !== undefined && clienteSelecionado.distanciaKm !== null">
                                Distância: {{ formatarDistancia(clienteSelecionado.distanciaKm) }}
                            </div>
                        </div>
                    </GmapInfoWindow>
                </GmapMap>

                <div v-if="!localizacaoUsuario" class="mapa-placeholder">
                    Aguardando localização do usuário...
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
  name: 'onde-encontrar-viewer',
  data() {
    return {
        produtoLista:[],
        coordenadasLista: [],
        localizacaoUsuario: null,
        localizacaoFallback: {
            latitude: -23.55052,
            longitude: -46.633308,
        },
        cidadeUsuario: null,
        mensagemLocalizacao: null,
        searchQuery: null,
        pagina:0,
        itensPorPagina: 20,
        paginaAtual: 0,
        totalPaginas: 0,
        totalRegistros: 0,
        carregandoProdutos: false,
        buscaIniciada: false,
        mapaMobileVisivel: false,
        mobileViewport: false,
        clienteSelecionado: null,
        infoWindowAberta: false,
        mapZoom: 12,
        mapaCarregado: false,
        mapRenderKey: 0,
        boundsMapaAtual: null,
        mapOptions: {
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
        },
        unidadeNegocioProdutos: 1
    }
  },
  computed: {
    mapCenter() {
      const localizacao = this.localizacaoAtual;

      return {
        lat: localizacao.latitude,
        lng: localizacao.longitude,
      };
    },
    localizacaoAtual() {
      return this.localizacaoUsuario || this.localizacaoFallback;
    },
    userMarkerIcon() {
      if (!(window.google && window.google.maps)) return null;

      return {
        path: window.google.maps.SymbolPath.CIRCLE,
        fillColor: '#1565c0',
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeOpacity: 1,
        strokeWeight: 3,
        scale: 10,
      };
    },
    possuiResultadosNoMapa() {
      return this.coordenadasLista && this.coordenadasLista.length > 0;
    },
    deveRenderizarPesquisa() {
      return !this.mobileViewport || !this.mapaMobileVisivel;
    },
    deveRenderizarMapa() {
      return !this.mobileViewport || this.mapaMobileVisivel;
    }
  },
  created() {
    this.atualizarViewportMobile();
    this.obterLocalizacaoUsuario();
  },
  mounted() {
    window.addEventListener('scroll', this.aoScrollResultados, { passive: true });
    window.addEventListener('resize', this.atualizarViewportMobile);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.aoScrollResultados);
    window.removeEventListener('resize', this.atualizarViewportMobile);
  },
  watch: {
    coordenadasLista() {
      this.forcarAtualizacaoMarcadores();
      this.ajustarMapaParaResultados();
    }
  },
  methods: {
    aoCarregarMapa() {
      this.mapaCarregado = true;
      this.atualizarBoundsMapa();
      if (this.coordenadasLista.length) {
        this.ajustarMapaParaResultados();
      }
    },
    atualizarBoundsMapa() {
      if (!(this.$refs.mapaOndeEncontrar && this.$refs.mapaOndeEncontrar.$mapPromise)) return;

      this.$refs.mapaOndeEncontrar.$mapPromise.then((map) => {
        const bounds = map.getBounds();
        if (!bounds) return;

        const northEast = bounds.getNorthEast();
        const southWest = bounds.getSouthWest();

        this.boundsMapaAtual = {
          latNorthEast: northEast.lat(),
          lngNorthEast: northEast.lng(),
          latSouthWest: southWest.lat(),
          lngSouthWest: southWest.lng(),
        };
      });
    },
    abrirDetalhesCliente(coordenada) {
      this.clienteSelecionado = coordenada;
      this.infoWindowAberta = true;
    },
    fecharDetalhesCliente() {
      this.infoWindowAberta = false;
    },
    formatarDistancia(distanciaKm) {
      return `${Number(distanciaKm).toFixed(2)} km`;
    },
    forcarAtualizacaoMarcadores() {
      this.mapRenderKey += 1;
    },
    atualizarViewportMobile() {
      this.mobileViewport = this.ehMobile();
    },
    obterLocalizacaoUsuario() {
      if (!navigator.geolocation) {
        console.warn('Geolocalização não suportada pelo navegador.');
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.localizacaoUsuario = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            precisao: position.coords.accuracy,
            altitude: position.coords.altitude,
            precisaoAltitude: position.coords.altitudeAccuracy,
            direcao: position.coords.heading,
            velocidade: position.coords.speed,
            timestamp: position.timestamp,
          };
          this.mensagemLocalizacao = null;
          this.obterCidadeUsuario();
          console.log('LOCALIZAÇÃO USUÁRIO:', this.localizacaoUsuario);
        },
        (error) => {
          console.error('Erro ao obter localização do usuário:', error);
          this.aplicarFallbackLocalizacao();
        },
        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 300000,
        }
      );
    },
    aplicarFallbackLocalizacao() {
      this.localizacaoUsuario = null;
      this.cidadeUsuario = 'Sao Paulo - SP';
      this.mensagemLocalizacao = 'Nao foi possivel obter sua localizacao exata. Usando Sao Paulo - SP como referencia.';
    },
    obterCidadeUsuario() {
      const localizacao = this.localizacaoAtual;
      if (!localizacao) return;

      if (!(window.google && window.google.maps)) {
        this.cidadeUsuario = `${localizacao.latitude.toFixed(4)}, ${localizacao.longitude.toFixed(4)}`;
        return;
      }

      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({
        location: {
          lat: localizacao.latitude,
          lng: localizacao.longitude,
        }
      }, (results, status) => {
        if (status !== 'OK' || !results || !results.length) {
          this.cidadeUsuario = `${localizacao.latitude.toFixed(4)}, ${localizacao.longitude.toFixed(4)}`;
          return;
        }

        const cidade = this.obterComponenteEndereco(results[0], 'administrative_area_level_2');
        const estado = this.obterComponenteEndereco(results[0], 'administrative_area_level_1', true);
        this.cidadeUsuario = [cidade, estado].filter(Boolean).join(' - ');
      });
    },
    obterComponenteEndereco(result, tipo, shortName) {
      if (!result || !result.address_components) return '';

      const componente = result.address_components.find((item) => item.types.indexOf(tipo) >= 0);
      if (!componente) return '';

      return shortName ? componente.short_name : componente.long_name;
    },
    productImage(product) {
      return product && product.id ? `webapi/item/${product.id}/fotoLow` : 'webapi/resource/foto_indisponivel.png';
    },
    handleImageError(event) {
      if (!event || !event.target) return;

      event.target.src = 'webapi/resource/foto_indisponivel.png';
    },
    aoScrollResultados(event) {
      if (this.mapaMobileVisivel) return;
      if (this.carregandoProdutos || !this.buscaIniciada) return;
      if (this.totalPaginas && this.paginaAtual >= this.totalPaginas - 1) return;

      const distanciaDoFim = this.obterDistanciaFimResultados(event);
      if (distanciaDoFim >= -80 && distanciaDoFim <= 80) {
        this.buscarProdutos({ proximaPagina: true });
      }
    },
    obterDistanciaFimResultados(event) {
      const painelResultados = this.$refs.painelResultados;
      const target = event && event.target;

      if (painelResultados && target === painelResultados) {
        return painelResultados.scrollHeight - (painelResultados.scrollTop + painelResultados.clientHeight);
      }

      if (painelResultados && painelResultados.getBoundingClientRect) {
        return painelResultados.getBoundingClientRect().bottom - window.innerHeight;
      }

      const documentElement = document.documentElement;
      return documentElement.scrollHeight - (window.pageYOffset + window.innerHeight);
    },
    resetarBuscaProdutos() {
      this.pagina = 0;
      this.paginaAtual = 0;
      this.totalPaginas = 0;
      this.totalRegistros = 0;
      this.produtoLista = [];

      this.$nextTick(() => {
        if (this.$refs.painelResultados) {
          this.$refs.painelResultados.scrollTop = 0;
        }
      });
    },
    buscarProdutos({ proximaPagina = false } = {}) {
        if (this.carregandoProdutos) return;

        if (!proximaPagina) {
          this.resetarBuscaProdutos();
        } else if (this.totalPaginas && this.paginaAtual >= this.totalPaginas - 1) {
          return;
        } else {
          this.pagina = this.paginaAtual + 1;
        }

        this.carregandoProdutos = true;
        this.buscaIniciada = true;

        this.$http.get('item/produtos', {
            params: {
                "id-empresa": 1,
                "id-categoria": 1,
                "query": this.searchQuery,
                "exibir-item-sem-foto": false,
                "pagina": this.pagina,
                "limite": this.itensPorPagina
            }
        })
        .then(rs => rs.json())
        .then(data => {
        const itens = data.itens || [];

        this.produtoLista = proximaPagina ? this.produtoLista.concat(itens) : itens;
        this.paginaAtual = data.pagina || 0;
        this.pagina = this.paginaAtual;
        this.totalPaginas = data.totalPaginas || 0;
        this.totalRegistros = data.totalRegistros || 0;
        })
        .then(() => console.log('PRODUTOS: ', this.produtoLista))
        .catch(error => console.error(error))
        .finally(() => {
          this.carregandoProdutos = false;
        });
    },
    focarMapa() {
      if (!this.ehMobile()) return;

      this.$nextTick(() => {
        const mapaWrapper = this.$refs.mapaWrapper;
        if (mapaWrapper) {
          mapaWrapper.focus({ preventScroll: true });
        }
        window.scrollTo(0, 0);
      });
    },
    ehMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 600px)').matches;
    },
    abrirMapaMobile() {
      if (!this.ehMobile()) return;

      this.mapaMobileVisivel = true;
      this.focarMapa();
    },
    novaPesquisaMobile() {
      this.mapaMobileVisivel = false;
      this.coordenadasLista = [];
      this.clienteSelecionado = null;
      this.infoWindowAberta = false;

      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    },
    buscarCoordenadas(sku) {
        const localizacao = this.localizacaoAtual;
        if (!localizacao) return;

        this.abrirMapaMobile();

        this.$http.get(`cliente/${sku}/onde_encontrar`, {
            params: {
                latitude: localizacao.latitude,
                longitude: localizacao.longitude
            }
        })
        .then(response => response.json())
        .then(list => {
          this.coordenadasLista = this.normalizarCoordenadas(list || []);
          this.clienteSelecionado = null;
          this.infoWindowAberta = false;
          console.log('COORDENADAS ENCONTRADAS:', this.coordenadasLista);
        })
        .catch(error => console.error(error));
    },
    gerarOffsetDeterministico(seed) {
      const seno = Math.sin(seed) * 10000;
      return seno - Math.floor(seno);
    },
    deslocarCoordenada(lat, lng, indice, chaveCoordenada) {
      if (indice === 0) {
        return { lat, lng };
      }

      const distanciaMaximaKm = 1;
      const seedBase = chaveCoordenada
        .split('')
        .reduce((total, caractere) => total + caractere.charCodeAt(0), 0) + (indice * 997);
      const angulo = this.gerarOffsetDeterministico(seedBase) * Math.PI * 2;
      const distanciaKm = 0.15 + (this.gerarOffsetDeterministico(seedBase + 17) * 0.85);
      const kmPorGrauLatitude = 111.32;
      const kmPorGrauLongitude = 111.32 * Math.cos((lat * Math.PI) / 180);
      const distanciaAjustadaKm = Math.min(distanciaMaximaKm, distanciaKm);
      const deltaLat = (distanciaAjustadaKm / kmPorGrauLatitude) * Math.sin(angulo);
      const deltaLng = kmPorGrauLongitude === 0
        ? 0
        : (distanciaAjustadaKm / kmPorGrauLongitude) * Math.cos(angulo);

      return {
        lat: lat + deltaLat,
        lng: lng + deltaLng,
      };
    },
    normalizarCoordenadas(lista) {
      const coordenadasPorPonto = {};

      return lista
        .map((coordenada, index) => {
          const latOriginal = Number(coordenada.clenLatitude);
          const lngOriginal = Number(coordenada.clenLongitude);

          if (isNaN(latOriginal) || isNaN(lngOriginal)) {
            return null;
          }

          const chaveCoordenada = `${latOriginal.toFixed(6)},${lngOriginal.toFixed(6)}`;
          const indiceNoMesmoPonto = coordenadasPorPonto[chaveCoordenada] || 0;
          const coordenadaDeslocada = this.deslocarCoordenada(latOriginal, lngOriginal, indiceNoMesmoPonto, chaveCoordenada);

          coordenadasPorPonto[chaveCoordenada] = indiceNoMesmoPonto + 1;

          return {
            id: `${coordenada.clieNome}-${index}`,
            clieNome: coordenada.clieNome,
            clieTelefone: coordenada.clieTelefone,
            clenLogradouro: coordenada.clenLogradouro,
            clenNumero: coordenada.clenNumero,
            clenBairro: coordenada.clenBairro,
            clenCep: coordenada.clenCep,
            clenMunicipio: coordenada.clenMunicipio,
            clenEstado: coordenada.clenEstado,
            distanciaKm: coordenada.distanciaKm,
            latOriginal,
            lngOriginal,
            lat: coordenadaDeslocada.lat,
            lng: coordenadaDeslocada.lng,
            position: { lat: coordenadaDeslocada.lat, lng: coordenadaDeslocada.lng }
          };
        })
        .filter((coordenada) => coordenada && !isNaN(coordenada.position.lat) && !isNaN(coordenada.position.lng));
    },
    obterBoundsMapa() {
      return new Promise((resolve) => {
        const localizacao = this.localizacaoAtual;
        const fallback = {
          latNorthEast: localizacao.latitude + 0.3,
          lngNorthEast: localizacao.longitude + 0.3,
          latSouthWest: localizacao.latitude - 0.3,
          lngSouthWest: localizacao.longitude - 0.3,
        };

        if (this.boundsMapaAtual) {
          resolve(this.boundsMapaAtual);
          return;
        }

        if (!(this.$refs.mapaOndeEncontrar && this.$refs.mapaOndeEncontrar.$mapPromise)) {
          resolve(fallback);
          return;
        }

        this.$refs.mapaOndeEncontrar.$mapPromise.then((map) => {
          const bounds = map.getBounds();
          if (!bounds) {
            resolve(fallback);
            return;
          }

          const northEast = bounds.getNorthEast();
          const southWest = bounds.getSouthWest();

          resolve({
            latNorthEast: northEast.lat(),
            lngNorthEast: northEast.lng(),
            latSouthWest: southWest.lat(),
            lngSouthWest: southWest.lng(),
          });
        }).catch(() => resolve(fallback));
      });
    },
    ajustarMapaParaResultados() {
      if (!this.mapaCarregado) return;
      if (!(this.$refs.mapaOndeEncontrar && this.$refs.mapaOndeEncontrar.$mapPromise && window.google && window.google.maps)) return;

      this.$nextTick(() => {
        this.$refs.mapaOndeEncontrar.$mapPromise.then((map) => {
          const bounds = new window.google.maps.LatLngBounds();

          if (this.localizacaoAtual) {
            bounds.extend(this.mapCenter);
          }

          this.coordenadasLista.forEach((coordenada) => {
            bounds.extend({ lat: coordenada.lat, lng: coordenada.lng });
          });

          if (!bounds.isEmpty()) {
            map.fitBounds(bounds);
            window.google.maps.event.addListenerOnce(map, 'idle', () => {
              this.atualizarBoundsMapa();
            });
          }
        });
      });
    },
  },
};
</script>

<style scoped>
.mapa-wrapper {
    position: relative;
    height: 100%;
    max-height: 100vh;
    background-color: #f5f5f5;
}

.mapa-onde-encontrar {
    width: 100%;
    height: 100%;
    max-height: 100vh;
}

.mapa-placeholder {
    position: absolute;
    top: 20px;
    left: 20px;
    padding: 12px 16px;
    background: rgba(255, 255, 255, 0.92);
    border-radius: 6px;
    color: #424242;
}

.busca-loading {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 0 16px;
    color: #424242;
}

.info-window-cliente {
    min-width: 220px;
    color: #424242;
    line-height: 1.5;
}

.info-window-cliente strong {
    display: block;
    margin-bottom: 6px;
}

.localizacao-fallback-msg {
    padding: 10px 12px;
    border-radius: 6px;
    background: #fff8e1;
    color: #6d4c41;
}

.onde-encontrar-layout {
    height: 100vh;
    max-height: 100vh;
    margin-bottom: 0;
}

.painel-resultados {
    height: 100vh;
    max-height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
}

.painel-mapa {
    height: 100vh;
    max-height: 100vh;
}

@media only screen and (max-width: 600px) {
    .onde-encontrar-layout {
        height: auto;
        max-height: none;
    }

    .painel-resultados {
        height: auto;
        max-height: none;
        overflow: visible;
    }

    .painel-mapa {
        height: auto;
        max-height: none;
    }

    .mapa-wrapper {
        height: 60vh;
        max-height: 60vh;
    }

    .mapa-onde-encontrar {
        max-height: 60vh;
    }
}
</style>



// WEBPACK FOOTER //
// OndeEncontrar.vue?0d3cd49f